import { render, staticRenderFns } from "./DisplayLayoutBoxNew.vue?vue&type=template&id=0041781a&lang=pug"
import script from "./DisplayLayoutBoxNew.vue?vue&type=script&lang=js"
export * from "./DisplayLayoutBoxNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports